import { Autocomplete, FormLabel } from '@mui/material';
import styled from 'styled-components';

import { NTeamManager } from '@modules/admin/AdminTools/TeamManager/tabs/Teams/interfaces';
import { LocalTabContent } from '@styles/CommonStyles';
import { colorTheme } from '@styles/muiTheme';

export const TeamManagerContent = styled(LocalTabContent)`
  flex-direction: row;
  display: flex;
  gap: 25px;
`;

export const TeamManagerColumn = styled.div<{ height?: string, minWidth?: string }>`
  width: 255px;
  min-width: ${({ minWidth }) => minWidth ? minWidth : '255px'};
  height: ${({ height }) => height ?? '100%'};
  display: inherit;
  flex-direction: column;
  gap: inherit;
`;

export const TeamWrapper = styled.div`
  gap: inherit;
  display: flex;
  flex-direction: column;
  height: calc(100% - 17px);
`;

export const TeamHeader = styled.div`
  width: 100%;
  display: flex;
  min-height: 45px;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    gap: 15px;
  }
`;

export const UsersListWrapper = styled.div<{ height?: string }>`
  border: 1px solid ${colorTheme.palette.secondary.main};
  border-radius: 4px;
  position: relative;
  height: ${({ height }) => height || '100%'};
`;

export const UserLists = styled.div`
  gap: 2%;
  display: flex;
  flex-direction: column;
  height: calc(100% - 70px);
`;

export const VerticalAutocomplete = styled(Autocomplete<NTeamManager.User, true, true>)`
  && {
    width: 100%;
    height: calc(100% - 90px);
    border: 1px solid ${colorTheme.palette.secondary.main};
    border-radius: 4px;

    .MuiTextField-root {
      height: 100%;
    }

    .MuiInputLabel-root {
      background: ${colorTheme.palette.common.white};
      padding: 0 5px;
      left: -5px;
    }

    fieldset {
      display: none;
    }

    .MuiInputBase-root {
      display: block;
      overflow: auto;
      height: 100%;
    }

    .MuiAutocomplete-tag {
      margin: 5px 0;
      max-width: 100%;
    }

    .MuiButtonBase-root,
    .MuiInputBase-input {
      display: flex;
      overflow: auto;
      justify-content: space-between;
    }

    .MuiInputBase-input {
      width: 190px;
    }
  }
`;

export const UnassignedAgentsWrapper = styled.div`
  height: calc(75vh - 90px);
  display: flex;
  flex-direction: column;

  ${UsersListWrapper} {
    flex: 1;
  }

  .MuiPagination-ul {
    justify-content: center;
  }
`;

export const UserListLabel = styled(FormLabel)`
  z-index: 1;
  top: -10px;
  left: 10px;
  background: ${colorTheme.palette.common.white};
  color: ${colorTheme.palette.common.black};
  font-weight: 400;
  font-size: 12px;
  padding: 0 5px;
  position: absolute;
  line-height: 1.4375em;
`;